import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AdminPortal from './pages/AdminPortal';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

const ADMIN_AUTH_KEY = 'saitour_admin_authenticated';
const ADMIN_HOST = (process.env.REACT_APP_ADMIN_HOST || '').toLowerCase();

const isAllowedAdminHost = () => {
  if (!ADMIN_HOST) return true;
  return window.location.hostname.toLowerCase() === ADMIN_HOST;
};

const ProtectedRoute = ({ isAuthenticated, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }
  return children;
};

function App() {
  const adminHostAllowed = isAllowedAdminHost();
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(
    () => localStorage.getItem(ADMIN_AUTH_KEY) === 'true'
  );

  const handleAdminLogin = (username, password) => {
    const expectedUsername = process.env.REACT_APP_ADMIN_USERNAME || 'admin';
    const expectedPassword = process.env.REACT_APP_ADMIN_PASSWORD || 'admin123';
    const isValid = username === expectedUsername && password === expectedPassword;

    if (isValid) {
      localStorage.setItem(ADMIN_AUTH_KEY, 'true');
      setIsAdminAuthenticated(true);
    }

    return isValid;
  };

  const handleAdminLogout = () => {
    localStorage.removeItem(ADMIN_AUTH_KEY);
    setIsAdminAuthenticated(false);
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/admin"
          element={
            adminHostAllowed ? (
              <AdminPortal
                isAuthenticated={isAdminAuthenticated}
                onLogin={handleAdminLogin}
                onLogout={handleAdminLogout}
              />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/admin/management"
          element={
            adminHostAllowed ? (
              <ProtectedRoute isAuthenticated={isAdminAuthenticated}>
                <AdminDashboard onLogout={handleAdminLogout} />
              </ProtectedRoute>
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
